import React from 'react';
import { propTypes } from 'react-bootstrap/esm/Image';
import './Button.css';

const Button =({children, ...rest})=>{

    return(
        <button style={rest.style}  className='button'{...rest}>
            {children}
        </button>
    )
}
export default Button;